import { Swiper, SwiperSlide } from 'swiper/react';
import { format } from "date-fns";
import { ru } from "date-fns/locale";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { FreeMode, Scrollbar, Navigation } from 'swiper/modules';
import { Link } from 'react-router-dom';
import { ImageLoader } from '../UI/ImageLoader';
import { Button, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';

//format(new Date(item.startOfEvent), 'dd.MM')} 
export const DateBtn = ({ schedule }) => {
    const date = new Date(schedule.startOfEvent);

    return (
        <div className="d-grid mt-1">
            <div className="d-flex justify-content-around gap-2">
                <div className="border border-1 shadow-sm rounded pt-1 pb-1 pe-4 ps-4 text-center afisha-date-btn">

                    {/* Время */}
                    <div style={{ fontSize: '1.5rem', fontWeight: '700', margin: '2px 0' }}>
                        {format(date, 'dd', { locale: ru })}
                    </div>
                    <div style={{ fontSize: '0.65rem', fontWeight: '600', margin: '2px 0' }}>
                        {format(date, 'MMM', { locale: ru }).toUpperCase().replace(".", "")}
                    </div>
                    {/* Дата + месяц */}

                </div>
                <div className='d-grid align-items-center'>
                    <div>
                        {/* День недели */}
                        <div className='text-center' style={{ fontSize: '0.55rem', fontWeight: '600', letterSpacing: '0.8px', textTransform: 'uppercase' }}>
                            {format(date, 'EEEEEE', { locale: ru }).toUpperCase()}
                        </div>
                        <div style={{ fontSize: '0.85rem', fontWeight: '500' }}>
                            {format(date, 'HH:mm')}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const SliderAfisha = ({ items }) => {
    const [t] = useTranslation("global");
    const refImg = useRef(null);
    const sizeSlider = () => {
        const itemsSize = items.length
        const result = {
            '@0.00': {
                slidesPerView: itemsSize > 1 ? 1.2 : itemsSize, // 2 полный + 0.2 частично видимого
                centeredSlides: false,
                spaceBetween: 20,
            },
            '@0.75': {
                slidesPerView: itemsSize > 1 ? 1.4 : itemsSize, // 1 полный + 0.5 частично видимого
                centeredSlides: false,
                spaceBetween: 30,
            },
            '@1.00': {
                slidesPerView: itemsSize > 3 ? 3.2 : itemsSize, // 2 полных + 0.2 частично видимого третьего
                centeredSlides: false,
                spaceBetween: 30,
            },
            '@1.50': {
                slidesPerView: itemsSize > 3 ? 4.2 : itemsSize, // 2 полных + 0.3 частично видимого третьего
                centeredSlides: false,
                spaceBetween: 40,
            },
            '@2.00': {
                slidesPerView: itemsSize > 3 ? 4.2 : itemsSize, // 2 полных + 0.4 частично видимого третьего
                centeredSlides: false,
                spaceBetween: 50,
            },
        }
        return result
    }

    useEffect(() => {
        console.log(refImg)
    }, [refImg])

    return (
        <Swiper
            slidesPerView={'auto'}
            spaceBetween={30}
            scrollbar={true}
            navigation={true}
            modules={[Scrollbar, FreeMode, Navigation]}
            className="afisha-swiper justify-content-center"
            breakpoints={sizeSlider()}
            // Добавляем отступ слева, чтобы первый слайд не прилипал к краю
            slidesOffsetBefore={items.length > 2 ? 20 : 0}
            slidesOffsetAfter={items.length > 2 ? 20 : 0}

        >
            {items.map((item) =>
                <SwiperSlide key={item.name} className='mb-3 afisha-swiper-slide'>
                    <div className='position-relative' >
                        {items.length > 1 ?
                            <div style={{ maxWidth: '400px', inset: 0, margin: 'auto' }}>
                                <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                                    <div style={{ minHeight: "60px" }} className='d-flex align-items-end'>
                                        <h4 className='afisha-event-title mt-3 mb-0 d-none d-md-block'>{item.name}</h4>
                                        <h4 className='afisha-event-title mt-3 mb-0 d-md-none'>{item.name}</h4>
                                    </div>
                                    <div className='position-relative text-center'>
                                        {/* <Image src={`/api/shows/afisha-img/${item.id}`} style={{maxHeight: '65vh'}} alt={item.name} fluid /> */}
                                        <ImageLoader ref={refImg} src={`https://leningradcenter.ru/api/shows/afisha-img/${item.id}`} name={item.name} mHeight={'65vh'} />
                                    </div>
                                    <div className='afisha-event-desc mt-0 mb-1 ms-1' style={{ fontSize: "0.75rem" }}>{item.description}</div>
                                </Link>
                                <div className='mt-1 mt-1'>
                                    <p className="text-muted text-center mb-0">Выберете дату</p>
                                </div>
                                <div className='ps-md-4 pe-md-4 ps-2 pe-2' >
                                    {item.showSchedules.length > 0 &&
                                        <div className='d-flex flex-wrap gap-2 justify-content-around' style={{ maxWidth: 1000 }}>
                                            {
                                                item.showSchedules.map((schedule) => (<DateBtn key={schedule.id} schedule={schedule} />)
                                                )
                                            }
                                            {
                                                item.showSchedules.map((schedule) => (<DateBtn key={schedule.id} schedule={schedule} />)
                                                )
                                            }
                                        </div>

                                    }
                                    {/* <ButtonAfisha item={item} setShowModel={setShowModel} setParam={setParam} hideModal={hideModal} searchParams={searchParams} setDateList={setDateList} /> */}
                                </div>

                            </div>
                            :
                            <>
                                <Row>
                                    <Col>
                                        <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                                            <div className='position-relative text-center'>
                                                {/* <div onClick={() => { toNav(`/about-project/show/${item.seoUrl}`) }} className='position-relative text-center'> */}
                                                <div className='d-md-none'>
                                                    <ImageLoader src={`/api/shows/afisha-img/${item.id}`} name={item.name} mHeight={'60vh'} />
                                                    {/* <Image alt={item.name} className='' src={`/api/shows/afisha-img/${item.id}`} fluid style={{ maxHeight: "60vh" }} /> */}
                                                </div>
                                                <div className='d-none d-md-block'>
                                                    <ImageLoader src={`/api/shows/head-img/${item.id}`} wide={true} name={item.name} mHeight={'70vh'} />
                                                    {/* <Image alt={item.name} src={`/api/shows/head-img/${item.id}`} fluid style={{ maxHeight: "70vh" }} /> */}
                                                </div>
                                            </div>
                                        </Link>
                                    </Col>
                                    <Col lg={4}>
                                        {/* <h4 onClick={() => { toNav(`/about-project/show/${item.id}`) }} className='afisha-event-title mt-3 mb-0'>{item.name}</h4> */}
                                        {/* <div className='afisha-event-desc mt-0 mb-1 ms-1' style={{ fontSize: "0.75rem" }}>{item.description}</div> */}
                                        <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                                            <h3 className='afisha-event-title mt-3 mb-0'>
                                                <strong>{item.name}</strong>
                                            </h3>
                                            <p>
                                                <strong>
                                                    {item.shortDescription}
                                                </strong>
                                            </p>
                                            {(item.director !== "" && item.director !== undefined) &&
                                                <p>
                                                    {t("show.director")} — <strong>
                                                        {item.director}
                                                    </strong>
                                                </p>
                                            }
                                            {/* <p className="d-none d-lg-block">
                                    {t("show.duration")}: {item.duration}
                                </p> */}
                                            <p>
                                                {t("show.age")} <strong>{item.ageCategory}+</strong>
                                            </p>
                                        </Link>
                                        {/* <div>
                                            <ButtonAfisha item={item} setShowModel={setShowModel} setParam={setParam} hideModal={hideModal} searchParams={searchParams} setDateList={setDateList} />
                                        </div> */}
                                    </Col>
                                </Row>
                            </>
                        }
                    </div>
                </SwiperSlide>
            )}
        </Swiper>
    )
}